module.exports = __webpack_public_path__ + "media/images/favicon-16x16-7462a24a052420c835cf1bc93b89e648.png";